import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'de_AQ',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: true,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '719418a2-3c7e-4690-ab88-fcac14a2f2c8',
  ''
);
